<template>
  <div class="page">
    <div class="header">Employee Giving</div>
    <div class="list-donation">
      <ItemSummary
        :loading="companyAdminStore.allDonationsLoading"
        :totalDonations="companyAdminStore.totalDonations"
        :totalAmountDonated="companyAdminStore.totalAmountDonated"
        :totalEmployees="companyAdminStore.totalEmployees"
        :showTotalEmployees="true"
      />
      <DataRows
        :loading="companyAdminStore.allDonationsLoading"
        :mainColor="donorStore.mainColor"
        :store="companyAdminStore"
        :items="companyAdminStore.allDonations || []"
        :onBrowse="redirectToCMS"
        :onExport="exportDonations"
        :showProfileName="false"
        :showEmployeeDetails="true"
        :searchFields="['organization.organizationName', 'employeeName']"
        noDonationsTitle="No donations have been made by employees yet."
        noDonationsMessage="Come back after donations have been made to view a list of employee contributions."
        :showBrowseButton="false"
        :sortByEmployeeName="true"
        :menuItems="menuItems"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeMount } from 'vue';
import { useDonorStore } from '@/stores/DonorStore.js';
import { useCompanyAdminStore } from '@/stores/CompanyAdminStore.js';
import { useSnackbarStore } from '@/stores/SnackbarStore.js';
import DataRows from '@/components/data/DataRows.vue';
import ItemSummary from '@/components/data/ItemSummary.vue';
import { exportDonations as exportDonationsHelper } from '@/helpers/exportHelper.js';

const donorStore = useDonorStore();
const companyAdminStore = useCompanyAdminStore();

const redirectToCMS = () => {
  window.location.href = donorStore.domain.replace(/\/$/, '') + '/organizations';
};

async function exportDonations() {
  const result = await exportDonationsHelper(companyAdminStore, companyAdminStore.filteredDonations);
  if (result === false) {
    useSnackbarStore().show('Failed to export donations.', 'error');
  }
}

const menuItems = [
  {
    text: 'Not an Employee',
    emit: 'removeEmployee',
    disabled: false,
    disabled_text: null,
    type: 'default',
  },
];

onBeforeMount(() => {
  companyAdminStore.getAllDonations();
  companyAdminStore.getStatistics();
});
</script>

<style scoped>
.list-donation {
  max-width: 930px;
}
@media (max-width: 1024px) {
  .list-donation {
    max-width: 680px;
  }
}
@media (max-width: 600px) {
  .list-donation {
    max-width: 100%;
  }
}
</style>
